import { alpha } from "@mui/material/styles";
// SETUP COLORS
const NEUTRAL = {
    700: "#495057",
    600: "#6C757D",
};
const GREY = {
    0: "#F9FAFB",
    100: "#F9FAFB",
    200: "#F4F6F8",
    300: "#DFE3E8",
    400: "#C4CDD5",
    500: "#919EAB",
    700: "#495057",
    600: "#6C757D",
    800: "#212B36",
    900: "#161C24",
};
const PRIMARY = {
    lighter: "#CBF3FF",
    light: "#00B6ED",
    main: "#3192D0",
    dark: "#0B51A1",
    darker: "#00244D",
    contrastText: "#FFFFFF",
};
const SECONDARY = {
    lighter: "#FEC3E0",
    light: "#DBD1DD",
    main: "#5E3168",
    dark: "#44174E",
    darker: "#78023D",
    contrastText: "#FFFFFF",
};
const INFO = {
    lighter: "#CAFDF5",
    light: "#61F3F3",
    main: "#00B8D9",
    dark: "#006C9C",
    darker: "#003768",
    contrastText: "#FFFFFF",
};
const SUCCESS = {
    lighter: "#E5FFC7",
    light: "#ABFF4A",
    main: "#76B82A",
    dark: "#4D850C",
    darker: "#315805",
    contrastText: "#ffffff",
};
const WARNING = {
    lighter: "#FFC3AF",
    light: "#FF7D53",
    main: "#E94E1B",
    dark: "#B33106",
    darker: "#7A2003",
    contrastText: GREY[800],
};
const ERROR = {
    lighter: "#FFB0B0",
    light: "#FF5A59",
    main: "#E52322",
    dark: "#AD0605",
    darker: "#750909",
    contrastText: "#FFFFFF",
};
const EDARK = {
    lighter: "#FFB0B0",
    light: "#00244D33",
    main: "#00244D",
    dark: "#2A2A2A",
    darker: "#1A1A1A",
    contrastText: "#FFFFFF",
};
const COMMON = {
    common: {
        black: "#130922",
        white: "#FFFFFF",
    },
    primary: PRIMARY,
    secondary: SECONDARY,
    info: INFO,
    success: SUCCESS,
    warning: WARNING,
    error: ERROR,
    grey: GREY,
    edark: EDARK,
    neutal: NEUTRAL,
    divider: alpha(GREY[500], 0.2),
    action: {
        hover: alpha(GREY[500], 0.08),
        selected: alpha(GREY[500], 0.16),
        disabled: alpha(GREY[500], 0.8),
        disabledBackground: alpha(GREY[500], 0.24),
        focus: alpha(GREY[500], 0.24),
        hoverOpacity: 0.08,
        disabledOpacity: 0.48,
    },
};
export function palette(mode) {
    const light = {
        ...COMMON,
        mode: "light",
        text: {
            primary: GREY[900],
            secondary: GREY[600],
            disabled: GREY[500],
            tertiary: '#637381'
        },
        background: {
            paper: "#FFFFFF",
            default: "#FFFFFF",
            neutral: GREY[200],
        },
        action: {
            ...COMMON.action,
            active: GREY[600],
        },
        edark: EDARK,
    };
    const dark = {
        ...COMMON,
        mode: "dark",
        text: {
            primary: "#161C24",
            secondary: "#454F5B",
            Blue: "#00244D",
            disabled: GREY[600],
        },
        background: {
            paper: GREY[800],
            default: GREY[900],
            neutral: alpha(GREY[500], 0.12),
        },
        action: {
            ...COMMON.action,
            active: GREY[500],
        },
        edark: EDARK,
    };
    return mode === "light" ? light : dark;
}
